module.exports = __webpack_public_path__ + "static/media/m_i.58bdc384.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/m_i.svg
// module id = 217
// module chunks = 0